import { render } from "./PdfUpload.vue?vue&type=template&id=97b40774&scoped=true"
import script from "./PdfUpload.vue?vue&type=script&lang=js"
export * from "./PdfUpload.vue?vue&type=script&lang=js"

import "./PdfUpload.vue?vue&type=style&index=0&id=97b40774&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b40774"]])

export default __exports__